import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { PlaceholderLoader } from '@hotelplan/components.common.placeholder-loader';
import { useDeviceType } from '@hotelplan/libs.context.device-type';
import { FdrProductCardContent } from 'fdr/components/local/fdr-product-card/fdr-product-card.styles';

const FdrGeoItemCard = styled(FdrProductCardContent)(
  ({ theme: { media } }) => ({
    borderWidth: 0,
    height: '100%',
    [media.tablet]: {
      height: '197px',
    },
  })
);

const FdrSrlGeoItemSkeleton = forwardRef<HTMLDivElement>((_, ref) => {
  const { mobile } = useDeviceType();

  const { w: width, h: height } = mobile
    ? { w: 290, h: 326 }
    : { w: 770, h: 197 };

  return (
    <FdrGeoItemCard ref={ref}>
      <PlaceholderLoader
        width={width}
        height={height}
        uid="cardSkeleton"
        style={{ height: '100%', width: '100%', display: 'block' }}
      >
        <path
          id="imageSkeleton"
          d={
            mobile
              ? `M0,147
                 v-142
                 q0,-5 5,-5
                 h280
                 q5,0 5,5
                 v142
                 h-290
                 z`
              : `M0,152
                 v-147
                 q0,-5 5,-5
                 h288
                 q5,0 5,5
                 v147
                 h-298
                 z`
          }
        />
        <rect
          id="title"
          x={mobile ? 16 : 330}
          y={mobile ? 147 + 16 + 2 : 22}
          rx="4"
          ry="4"
          width={100}
          height={18}
        />
        <rect
          id="offerCount"
          x={mobile ? 16 : 330}
          y={mobile ? 147 + 16 + 22 + 5 + 4 : 22 + 29}
          rx="4"
          ry="4"
          width={60}
          height={14}
        />
        <rect
          id="flightTime"
          x={mobile ? 16 : 330}
          y={mobile ? 147 + 16 + 27 + 25 + 4 : 22 + 29 + 29}
          rx="4"
          ry="4"
          width={150}
          height={16}
        />
        <rect
          id="dates"
          x={mobile ? 16 : 330}
          y={mobile ? 147 + 16 + 27 + 25 + 28 + 4 : 22 + 29 + 29 + 29}
          rx="4"
          ry="4"
          width={170}
          height={16}
        />
        <rect
          id="bottomLine"
          x="0"
          y={mobile ? 288 : 152}
          width={mobile ? 290 : 770}
          height="1"
        />
        <rect
          id="rightButton"
          x={mobile ? 290 - 22 : 770 - 26}
          y={mobile ? 289 : 153}
          width={mobile ? 22 : 26}
          height={mobile ? 326 - 289 : 197 - 152}
        />
        <rect
          id="price"
          x={135}
          y={298}
          rx="4"
          ry="4"
          width={120}
          height={18}
        />
      </PlaceholderLoader>
    </FdrGeoItemCard>
  );
});

export default FdrSrlGeoItemSkeleton;
